import {
  clearCreateNewException,
  getCreateNewExceptionFail,
  getCreateNewExceptionStarted,
  getCreateNewExceptionSuccess,
} from '../../../reducer/exceptions/GetCreateNewExceptionReducer';
import { createNewException } from '../../actionType/services/ServiceActionTypes';
import {
  ClearGetCreateNewException,
  GetCreateNewExceptionFailure,
  GetCreateNewExceptionFailurePayload,
  GetCreateNewExceptionRequest,
  GetCreateNewExceptionStarted,
  GetCreateNewExceptionSuccess,
  GetCreateNewExceptionSuccessPayload,
} from '../../types/exceptions/CreateNewExceptionTypes';

export const getCreateNewExceptionRequest = (reqObject: any): GetCreateNewExceptionRequest => ({
  type: createNewException.CREATE_NEW_EXCEPTION_REQUEST,
  requestObject: reqObject,
});

/**
 * get metric summary started saga action
 * @returns get metric summary action
 */
export const getCreateNewExceptionStart = (): GetCreateNewExceptionStarted => ({
  type: getCreateNewExceptionStarted.type,
});

/**
 * Get metric summary success saga action
 * @param payload :Metric data
 * @returns success action
 */
export const getCreateNewExceptionSuccessful = (
  payload: GetCreateNewExceptionSuccessPayload
): GetCreateNewExceptionSuccess => ({
  type: getCreateNewExceptionSuccess.type,
  payload,
});

/**
 * get metric Failed saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const getCreateNewExceptionFailure = (
  payload: GetCreateNewExceptionFailurePayload
): GetCreateNewExceptionFailure => ({
  type: getCreateNewExceptionFail.type,
  payload,
});

/**
 * Clear metrics saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const cleargetCreateNewException = (): ClearGetCreateNewException => ({
  type: clearCreateNewException.type,
});
